import { render } from "./Register.vue?vue&type=template&id=1f8f8188&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=1f8f8188&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8f8188"]])

export default __exports__